import React from 'react';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import uuidv4 from 'uuid/v4';

import client from '../../../utils/apolloClient';

// input: {
//   from: 10
//   user_id: ""
//   size: 10
//   sort: ""
//   filter: {
//     cms_data_filter: { cms_data_type: "", id: "", name: "", status: "" }
//   }
// }

const searchCmsDataQuery = gql`
  query searchCmsDataQuery($input: SearchInput) {
    search_cms_data(input: $input) {
      total_pages
      total_size
      cms_data {
        applies_to
        audit {
          created_at
          created_by
          updated_at
          updated_by
        }
        can_override
        cms_data_type
        description
        display_order
        error {
          code
          description
        }
        fee_value_type
        id
        label
        name
        sales_method
        service_type
        value
        status
      }
    }
  }
`;

const fetchApiActions = async ({
  id,
  name,
  status,
  from,
  size,
  sort,
  cmsDataType,
}) => {
  const input = { from, size, sort };

  input.filter = {};

  input.filter.cms_data_filter = {};

  if (id) {
    input.filter.cms_data_filter.id = id;
  }

  if (name) {
    input.filter.cms_data_filter.name = name;
  }

  if (status) {
    input.filter.cms_data_filter.status = status;
  }

  if (cmsDataType) {
    input.filter.cms_data_filter.cms_data_type = cmsDataType;
  }

  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchCmsDataQuery,
      variables: { input },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.search_cms_data) {
      return data.data.search_cms_data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

export const useCmsData = ({
  id,
  name,
  status,
  from,
  size,
  sort,
  cmsDataType,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(null);
  const [totalElements, setTotalElements] = React.useState(null);
  const [cmsData, setCmsData] = React.useState(null);
  const [reload, setReload] = React.useState(uuidv4());

  React.useEffect(() => {
    let loadData = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchApiActions({
          id,
          name,
          status,
          from,
          size,
          sort,
          cmsDataType,
        });
        if (loadData) {
          setPageCount(data.total_pages);
          setTotalElements(data.total_size);
          setCmsData(data?.cms_data ?? []);
          setLoading(false);
        }
      } catch (error) {
        toast.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    return () => {
      loadData = false;
    };
  }, [id, name, status, from, size, sort, cmsDataType, reload]);

  return {
    loading,
    pageCount,
    totalElements,
    cmsData,
    refetch: () => setReload(uuidv4()),
  };
};

export default {};
